import React from "react";
import { ProductAdded } from "Requests/Partners/PreBudgets";
import { Box } from "styles/globalComponents";
import { CartItem } from "Components/PreOrder/CartItem";
import HomeIcon from "Assets/Images/home-icon.png";
import { AttendmentListContainer } from "Pages/PreBudgetConvertion/styles";

interface CartListItemsProps {
  items: ProductAdded[] | any[]; // Aceita ambos os tipos
  loadingOperation: null | number;
  addUnitItem: (productId: number) => void;
  removeUnitItem: (productId: number) => void;
  blockedUserInteraction: boolean;
  deleteItem: (productId: number) => void;
}

export const CartListItems = ({
  items,
  loadingOperation,
  addUnitItem,
  removeUnitItem,
  deleteItem,
  blockedUserInteraction,
}: CartListItemsProps) => {
  return items.length >= 1 ? (
    <AttendmentListContainer>
      <section className="budget-collect-type">
        <Box display="flex" gap="10" align="center">
          <img src={HomeIcon} alt="" />
          <p className="collect-title">
            <strong>ATENDIMENTO DOMICILIAR</strong> <br />
          </p>
        </Box>
      </section>
      <div className="cart-itens-holder new-layout-cart-itens-holder">
        {items.map((item) => (
          <CartItem
            key={item?.product_id}
            product={item}
            addUnitItem={addUnitItem}
            removeUnitItem={removeUnitItem}
            deleteItem={deleteItem} // Função vazia para compatibilidade
            loadingOp={item.product_id === loadingOperation}
            blockedUserInteraction={blockedUserInteraction}
          />
        ))}
      </div>
    </AttendmentListContainer>
  ) : null;
};
